export const REPORT_ENDPOINT = `report`;
